import angular from 'angular';
import './styles.styl';
import uiCianModalAdapter from '../../adapters/ui.bootstrap.modal/modal.module';
import uiCianScrollWidth from '../scroll-width/index';

export default angular
	.module('ui.cian.modal', [uiCianModalAdapter, uiCianScrollWidth])
	.directive('beforeOpenModal', ['cianUiScrollWidth', '$document', (cianUiScrollWidth, $document) => ({
		link() {
			const $body = angular.element($document[0].body);
			const documentHeight = $document[0].body.clientHeight;
			const documentScrollHeight = $document[0].body.scrollHeight;
			const hasScroll = documentScrollHeight > documentHeight;
			$body.removeClass('has-scroll');
			if (hasScroll) {
				$body.addClass('has-scroll');
			}
		}
	})])
	.run(['cianUiScrollWidth', (cianUiScrollWidth) => {
		cianUiScrollWidth.createIndentTo(['.modal-open.has-scroll']);
	}])
	.name;



// WEBPACK FOOTER //
// ./~/@cian/ui/app/components/modal/index.jsm